import { httpGetAuth } from './axios';

export function getProfileAPI(params) {
  return httpGetAuth('/user-profile', params);
}
